// One app-wide timezone: every Date.toLocale*String call renders in the owner's saved posting timezone
// (Settings → Profile), falling back to the device clock. Patched once at startup so all 300+ call sites follow.
const ORIG = {
  s: Date.prototype.toLocaleString,
  d: Date.prototype.toLocaleDateString,
  t: Date.prototype.toLocaleTimeString,
};
let current = null;

export const deviceTimezone = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch { return 'UTC'; }
};

export const isValidTimezone = (tz) => {
  if (!tz) return false;
  try { new Intl.DateTimeFormat('en-US', { timeZone: tz }); return true; } catch { return false; }
};

export const setAppTimezone = (tz) => { current = isValidTimezone(tz) ? tz : null; window.dispatchEvent(new Event('app:timezone')); };
export const getAppTimezone = () => current || deviceTimezone();

const wrap = (orig) => function patched(locales, options) {
  if (!current || (options && options.timeZone)) return orig.call(this, locales, options);
  return orig.call(this, locales, { ...(options || {}), timeZone: current });
};
Date.prototype.toLocaleString = wrap(ORIG.s);
Date.prototype.toLocaleDateString = wrap(ORIG.d);
Date.prototype.toLocaleTimeString = wrap(ORIG.t);

// 'YYYY-MM-DD' of an instant in the app timezone (calendar day bucketing).
export const dayKeyInAppTz = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-CA', { timeZone: getAppTimezone(), year: 'numeric', month: '2-digit', day: '2-digit' });
};

export const allTimezones = () => {
  try { return Intl.supportedValuesOf('timeZone'); } catch {
    return ['UTC', 'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/Toronto', 'America/Sao_Paulo', 'Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Lisbon', 'Asia/Dubai', 'Asia/Kolkata', 'Asia/Singapore', 'Asia/Tokyo', 'Australia/Sydney'];
  }
};

export const tzOffsetLabel = (tz) => {
  try {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'shortOffset' }).formatToParts(new Date());
    return parts.find((p) => p.type === 'timeZoneName')?.value || '';
  } catch { return ''; }
};
